import { useAppSelector } from '../store/useStore';

export const useGetUserProfile = () => {
  const userProfileState = useAppSelector((state) => state.userProfile);
  return { userProfile: userProfileState.userProfile };
};
